/**
 * Device detection — port 1:1 din legacy window.device.
 * Detecteaza touch + mobile + event name-uri folosite de customEvents.swipe.
 */

export interface DeviceInfo {
    touchCapable:      boolean;
    isMobile:          boolean;
    swipe_h_threshold: number;
    swipe_v_threshold: number;
    startevent:        string;
    endevent:          string;
    moveevent:         string;
}

const touchCapable = 'ontouchstart' in window;

export const device: DeviceInfo = {
    touchCapable,
    isMobile:          /Mobi/.test(navigator.userAgent),
    swipe_h_threshold: 50,
    swipe_v_threshold: 50,
    startevent:        touchCapable ? 'touchstart' : 'mousedown',
    endevent:          touchCapable ? 'touchend'   : 'mouseup',
    moveevent:         touchCapable ? 'touchmove'  : 'mousemove',
};

(window as unknown as { device: DeviceInfo }).device = device;
